export default __webpack_public_path__ + "static/media/cause2.0a4ae926.png";